module.exports = __webpack_public_path__ + "img/img_conference_1.e4764ff3.png";